// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PAX_tD {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--neutral-dark-opacity-50);
  z-index: 1049;
  display: flex;
  justify-content: flex-end;
}

.GlsoAA {
  border: none;
  padding: 0;
  display: none;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  position: fixed;
  top: 0;
  right: 0;
  left: auto;
  width: 480px;
  height: 100vh;
  min-height: 100vh;
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s) 0 0 var(--radius-s);
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  cursor: default;
  z-index: 1050;
  overflow-y: auto;
}

.GlsoAA::-webkit-scrollbar {
  width: var(--spacing-1);
}

.GlsoAA::-webkit-scrollbar-thumb {
  width: var(--spacing-1);
  background-color: var(--text-neutral-subtle);
  border-radius: var(--radius-m);
}

.GlsoAA:focus {
  outline: none;
}

.GlsoAA[open] {
  display: flex;
  margin: 0;
  height: 100vh;
  min-height: 100vh;
}

.yrd0iH {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: var(--surface-neutral-white);
}

.yK0M9a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 36px;
  gap: var(--spacing-1);
  padding: var(--spacing-3);
  padding-bottom: 0;
}

.EFSOml {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
}

.KFHfnC {
  width: 16px;
  height: 16px;
}

.fMlPTU {
  font-family: var(--font-family-base);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.JdabgA {
  display: flex;
  justify-content: center;
  padding: var(--spacing-1) var(--spacing-3) 0;
  box-shadow: inset 0 -1px 0 #e5e7eb;
}

.siisbu {
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 400;
  border: none;
  border-bottom: 2px solid transparent;
  background: none;
  color: #6b7280;
  cursor: pointer;
  transition:
    color 0.2s ease-in-out,
    border-bottom-color 0.2s ease-in-out;
}

.siisbu:hover {
  color: #374151;
}

.siisbu.a4Wk9t {
  color: #ea580c;
  font-weight: 500;
  border-bottom: 2px solid #ea580c;
  background-color: #ffffff;
}

.SccrHS {
  flex: 1;
  overflow-y: auto;
  overflow-x: visible;
  padding: var(--spacing-3);
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/PixLimits/PixLimits.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,wCAAwC;EACxC,kDAAkD;EAClD,2CAA2C;EAC3C,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf;;wCAEsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B","sourcesContent":[".modalBackdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--neutral-dark-opacity-50);\n  z-index: 1049;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.modal {\n  border: none;\n  padding: 0;\n  display: none;\n  flex: 1;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: auto;\n  width: 480px;\n  height: 100vh;\n  min-height: 100vh;\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s) 0 0 var(--radius-s);\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);\n  box-sizing: border-box;\n  cursor: default;\n  z-index: 1050;\n  overflow-y: auto;\n}\n\n.modal::-webkit-scrollbar {\n  width: var(--spacing-1);\n}\n\n.modal::-webkit-scrollbar-thumb {\n  width: var(--spacing-1);\n  background-color: var(--text-neutral-subtle);\n  border-radius: var(--radius-m);\n}\n\n.modal:focus {\n  outline: none;\n}\n\n.modal[open] {\n  display: flex;\n  margin: 0;\n  height: 100vh;\n  min-height: 100vh;\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  background: var(--surface-neutral-white);\n}\n\n.header {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  height: 36px;\n  gap: var(--spacing-1);\n  padding: var(--spacing-3);\n  padding-bottom: 0;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n}\n\n.chevronLeft {\n  width: 16px;\n  height: 16px;\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.tabs {\n  display: flex;\n  justify-content: center;\n  padding: var(--spacing-1) var(--spacing-3) 0;\n  box-shadow: inset 0 -1px 0 #e5e7eb;\n}\n\n.tab {\n  padding: 12px 16px;\n  font-size: 14px;\n  font-weight: 400;\n  border: none;\n  border-bottom: 2px solid transparent;\n  background: none;\n  color: #6b7280;\n  cursor: pointer;\n  transition:\n    color 0.2s ease-in-out,\n    border-bottom-color 0.2s ease-in-out;\n}\n\n.tab:hover {\n  color: #374151;\n}\n\n.tab.active {\n  color: #ea580c;\n  font-weight: 500;\n  border-bottom: 2px solid #ea580c;\n  background-color: #ffffff;\n}\n\n.content {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: visible;\n  padding: var(--spacing-3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalBackdrop": `PAX_tD`,
	"modal": `GlsoAA`,
	"container": `yrd0iH`,
	"header": `yK0M9a`,
	"closeButton": `EFSOml`,
	"chevronLeft": `KFHfnC`,
	"title": `fMlPTU`,
	"tabs": `JdabgA`,
	"tab": `siisbu`,
	"active": `a4Wk9t`,
	"content": `SccrHS`
};
module.exports = ___CSS_LOADER_EXPORT___;
